export const MAX_FILE_SIZE = 1000000000;



// WEBPACK FOOTER //
// ./src/pages/importpictures/helpers/constants.js